import { stashAnswer } from "@/api/endpoints/answer/stashAnswer";
import debounce from 'quasar/src/utils/debounce.js';;
import Vue from "vue";
export const GlobalProxy = new Vue();
import $vm from "@/main";
import LocalForageManager from "@/libs/LocalForageManager";

const wait = parseInt(process.env.VUE_APP_QUESTIONNAIRE_CACHE_DELAY) || 10000;

GlobalProxy.$data.pushValidatedAnswerCache = debounce(
  async (sampleId: string, answer: any) => {
    try {
      const lock = $vm.$store.state.questionnaire.lockCache;
      if (lock) return;

      answer["__version__"] = new Date().getTime();

      const nativeAnswerCacheManger = new LocalForageManager("answer_cache");
      nativeAnswerCacheManger.set(sampleId, answer);
      await stashAnswer(sampleId, answer);
    } catch (err) {
      console.log(err);
    }
  },
  wait
);
